const InputFieldLabel = ({ className, label, isRequired }) => {
  return (
    <p className={"text-base " + className}>
      {label} {isRequired ? <span className="text-danger">*</span> : <></>}
    </p>
  );
};

export default InputFieldLabel;